import actions from "~/shared/actions";
import type { Action } from "~/utils/actions/action-utils";
import type { Policy } from "../policies";

function receiveHoldingsHistory(state, { polisenummer, period, holdingsHistoryForPolicy }) {
	const { marketValueAtDates, ...holdingsHistorySummary } = holdingsHistoryForPolicy;
	let list: { polisenummer: number; period: string; holdingsHistoryForPolicy: any; marketValueAtDatesForPolicy: any }[] = [];
	if (state.list.find((policy: Policy) => policy.polisenummer === polisenummer)) {
		list = state.list.map((policy: Policy) => {
			if (policy.polisenummer !== polisenummer) return { ...policy };

			return {
				...policy,
				period,
				holdingsHistoryForPolicy: holdingsHistorySummary,
				marketValueAtDatesForPolicy: { marketValueAtDates },
			};
		});
	} else {
		list.push({
			polisenummer,
			period,
			holdingsHistoryForPolicy: holdingsHistorySummary,
			marketValueAtDatesForPolicy: { marketValueAtDates },
		});
	}
	return { ...state, list };
}

export const defaultState = {
	list: [],
};

export default function holdingsHistory(state = defaultState, action: Action) {
	switch (action.type) {
		case actions.HOLDINGS_HISTORY_RESPONSE:
			return receiveHoldingsHistory(state, action.data);
		default:
			return state;
	}
}
